<template>
    <div class="d-flex justify-content-center "
        style="		box-shadow: -5px 8px 11px 0px rgba(176,159,159,0.4);     margin: 1%;
    padding: 30px;">

        <div class="row " style="width: 95%;">
            <b-col v-if="info.wallet == 1" >
                <a-tag color="green">شارژ کیف پول</a-tag>

            </b-col>
            <b-col :md="12">
                <a-row type="flex" :gutter="24">

                    <a-col :span="12" :xl="6" class="mb-24">

                        <!-- Salary Card -->
                        <a-card :bordered="false" class="widget-2 h-full">
                            <a-statistic :value="info.user ? info.user.firstname + ' ' + info.user.lastname: ''">
                                <template #title>
                                    <p>نام خریدار</p>
                                </template>
                            </a-statistic>
                        </a-card>

                        <!-- / Salary Card -->

                    </a-col>
                    <a-col :span="12" :xl="6" class="mb-24">

                        <!-- Salary Card -->
                        <a-card :bordered="false" class="widget-2 h-full">
                            <a-statistic
                                :value="info.paid_date != null ? new Date(info.paid_date).toLocaleDateString('fa-IR') : '-'">
                                <template #title>
                                    <p> تاریخ پرداخت</p>
                                </template>
                            </a-statistic>
                        </a-card>

                        <!-- / Salary Card -->

                    </a-col>
                    <a-col :span="12" :xl="6" class="mb-24">

                        <!-- Salary Card -->
                        <a-card :bordered="false" class="widget-2 h-full">
                            <a-statistic :value="info.payment_type == 'gate' ? 'درگاه پرداخت' : 'کیف پول'">
                                <template #title>
                                    <p>شیوه پرداخت</p>
                                </template>
                            </a-statistic>
                        </a-card>

                        <!-- / Salary Card -->

                    </a-col>
                    <a-col :span="12" :xl="6" class="mb-24">

                        <!-- Salary Card -->
                        <a-card :bordered="false" class="widget-2 h-full">
                            <a-statistic :style="{ color: '#' + info.status.color }" :value="info.status.title">
                                <template #title>
                                    <p>وضعیت سفارش </p>
                                </template>
                            </a-statistic>
                        </a-card>

                        <!-- / Salary Card -->

                    </a-col>



                    <a-col :span="24" class="mb-24" >
                        <!-- Payment Methods Card -->
                        <a-card :bordered="false" class="header-solid h-full">

                            <a-row :gutter="[24, 24]">
                                <a-col :span="24" :md="12" v-if="info.payment_type == 'gate'">
                                    <a-card class="payment-method-card">
                                        <span>شماره پیگیری درگاه</span>:
                                        <h6 class="card-number">{{ info . ref_id }}</h6>

                                    </a-card>
                                </a-col>
                                <a-col :span="24" :md="12" v-if="info.payment_type == 'gate'">
                                    <a-card class="payment-method-card">
                                        <span>شماره مرجع</span>:
                                        <h6 class="card-number">{{ info . tracking_code }}</h6>

                                    </a-card>
                                </a-col>
                                <a-col :span="24" :md="12">
                                    <a-card class="payment-method-card">
                                        <span> مبلغ تهاتری اصلی</span>:
                                        <h6 class="card-number">{{ $root . number_format(info . main_barter) }}</h6>

                                    </a-card>
                                </a-col>
                                <a-col :span="24" :md="12">
                                    <a-card class="payment-method-card">
                                        <span>مبلغ نقدی اصلی</span>:
                                        <h6 class="card-number">{{ $root . number_format(info . main_total) }}</h6>

                                    </a-card>
                                </a-col>
                                <a-col :span="24" :md="12">
                                    <a-card class="payment-method-card">
                                        <span> مبلغ تهاتری نهایی</span>:
                                        <h6 class="card-number">{{ $root . number_format(info . barter) }}</h6>

                                    </a-card>
                                </a-col>
                                <a-col :span="24" :md="12">
                                    <a-card class="payment-method-card">
                                        <span> مبلغ نقدی نهایی</span>:
                                        <h6 class="card-number">{{ $root . number_format(info . total) }}</h6>

                                    </a-card>
                                </a-col>
                            </a-row>
                        </a-card>
                        <!-- Payment Methods Card -->

                    </a-col>
                </a-row>
            </b-col>
           
    
            <b-col v-if="info.wallet != 1" :md="12" class="mb-24">

                <a-card :bordered="false" class="header-solid h-full"
                    :bodyStyle="{ paddingTop: '10px', paddingBottom: '16px' }">
                    <template #title>
                        <h6 class="font-semibold m-0">جزییات سفارش </h6>
                    </template>
                    <a-row :gutter="[24, 24]">
                        <a-col v-for="item in info.items" :span="24">
                            <a-card :bordered="false" class="card-billing-info">
                                <div class="col-info">
                                    <img :src="item.product.images.length > 0 ? $root.image_concat(item.product.images[0].path) : ''" alt=""
                                        width="150px" height="150px" style="padding: 10px;">
                                </div>
                                <div class="col-info">
                                    <br>
                                    <a-descriptions :column="1">
                                        <a-descriptions-item label="نام محصول">
                                            {{ item . product . title }}
                                        </a-descriptions-item>
                                        <a-descriptions-item label="نام فروشنده">
                                            {{item.product.presenter ?  item . product . presenter . firstname + ' ' + item . product . presenter . lastname : '' }}
                                        </a-descriptions-item>

                                        <a-descriptions-item label="شماره فاکتور ">
                                            {{ item . received_code }}
                                        </a-descriptions-item>

                                        <a-descriptions-item label=" وضعیت دریافت ">

                                            <a-tag color="green" v-if="item.received == 1">
                                                تحویل داده شده
                                            </a-tag>
                                            <a-tag v-else color="red">
                                                دریافت نشده
                                            </a-tag>


                                        </a-descriptions-item>


                                    </a-descriptions>
                                </div>
                                <div class="col-info">
                                    <br>
                                    <a-descriptions :column="1">
                                        <a-descriptions-item label="نوع متغیر">
                                            {{ item . product_variable_id != null ? item . product_variable . type . title : '-' }}
                                        </a-descriptions-item>

                                        <a-descriptions-item label="مقدار متغیر ">
                                            {{ item . product_variable_id != null ? item . product_variable . value . title : '-' }}
                                        </a-descriptions-item>


                                        <a-descriptions-item label="تعداد ">
                                            x {{ item . quantity }}
                                        </a-descriptions-item>
                                        <a-descriptions-item label=" تاریخ انقضا ">
                                            {{ item . product . expired_date != null ? new Date(item . product . expired_date) . toLocaleDateString('fa-IR') : '-' }}
                                        </a-descriptions-item>
                                    </a-descriptions>
                                </div>
                                <div class="col-info">
                                    <br>
                                    <a-descriptions :column="1">
                                        <a-descriptions-item label=" مبلغ اصلی">
                                            <a-tag>{{ $root . number_format(item . cost) }}</a-tag>
                                        </a-descriptions-item>
                                        <a-descriptions-item label=" مبلغ اصلی با تخفیف ">
                                            <a-tag>{{ $root . number_format(item . discounted_cost) }}</a-tag>
                                        </a-descriptions-item>
                                        <a-descriptions-item label="  مبلغ نقدی ">
                                            <a-tag>{{ $root . number_format(item . main_cash) }}</a-tag>
                                        </a-descriptions-item>
                                        <a-descriptions-item label="مبلغ تهاتری ">
                                            <a-tag>{{ $root . number_format(item . main_barter) }}</a-tag>
                                        </a-descriptions-item>
                                    </a-descriptions>
                                </div>

                            </a-card>
                        </a-col>
                    </a-row>
                </a-card>
            </b-col>
            

        </div>



    </div>
</template>

<script>
  
    export default ({

        data() {
            return {
                info: {},
            }
        },
        methods:{
            getData(){
                let _this = this;
            axios
                .get("/orders/single/" + this.$route.params.id)
                .then(function(response) {
                    console.log(response)
                    _this.info = response.data;
                })
                .catch(function(err) {
                    _this.$root.handleAxiosError(err);
                });
            }
        },
        mounted() {
            this.getData();

        },
    })
</script>

<style lang="scss">
</style>
